import {
  Row,
  Col,
  Card,
  message,
  Form,
  Input,
  Switch,
  ColorPicker,
  Checkbox,
  Timeline,
  InputNumber
} from "antd";
import { useState, useEffect } from "react";
import axios from "axios";
import ClassifyStructure from "../classify/Main";
import InformationModal from "../classify/components/InformationModal";

const RouteSetting = ({ prefixTitle = "" }) => {
  const [permissionData, setPermissionData] = useState([]);
  const [permissionProcessData, setPermissionProcessData] = useState([]);
  const [permissionId, setPermissionId] = useState();
  // const [permissionName, setPermissionName] = useState([]);
  const [checkStrictly, setCheckStrictly] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [colorData, setColorData] = useState({});
  const [fontData, setFontData] = useState({});
  const [modalData, setModalData] = useState({
    edit: true,
    prefix: "permission",
    languageKey: "permission_language_data",
    node: [],
    data: {
      name: "",
      pathCheck: false,
      path: "",
      show: true,
      property_json: {
        background_color1: "",
        background_color2: "",
      },
      subheading: "",
    },
  });

  const cancelModal = () => {
    setColorData({});
    setFontData({});
    setCheckStrictly(false);
    setModalData({
      edit: true,
      prefix: "permission",
      languageKey: "permission_language_data",
      node: [],
      data: {
        name: "",
        pathCheck: false,
        show: 1,
        property_json: {
          background_color1: "",
          background_color2: "",
        },
        subheading: "",
      },
    });
    setColorData({});
    setFontData({});
  };

  const addModal = (prefix, languageKey, node) => {
    setModalData((prev) => {
      return {
        ...prev,
        edit: false,
        // prefix: prefix,
        // languageKey: languageKey,
        node: node,
        data: {
          name: "",
          pathCheck: false,
          show: true,
          property_json: {},
          subheading: "",
        },
      };
    });
    setColorData({});
    setFontData({});
    setModalShow(true);
  };
  const createPermissionNode = (values, selectedNode) => {
    // console.log(values)
    let url = `/dynamicWebsite/backend/permission`;
    let classify_structure_type_id = 0;
    let hasParent = 0;

    if (selectedNode?.classify_structure_type_id) {
      classify_structure_type_id = selectedNode?.classify_structure_type_id;
      hasParent = 1;
    } //有沒有selected
    let data = {
      classify_structure_id: 5,
      classify_structure_type_id: classify_structure_type_id,
      name: values.name,
      path_check: 1,
      show: values.show ? 1 : 0,
      property_json: JSON.stringify({}),
      subheading: "",
      permission_language_data: [
        {
          language_culture_code: "zh-tw",
          language_culture_value: values.name,
        },
        {
          language_culture_code: "en",
          language_culture_value: values.nameEn,
        },
      ],
    };
    if (values.pathCheck) {
      data = {
        ...data,
        path_check: 0,
        path: values.path,
      };
    }

    createNode("permission", values, selectedNode, url, data, hasParent);
  };
  const createNode = (type, values, selectedNode, url, data, hasParent) => {
    // console.log("selectedNode", selectedNode)

    if (hasParent) {
      //有沒有selected

      axios
        .post(url, data)
        .then((response) => {
          if (response.data.status === "success") {
            message.success("新增成功");
            setPermissionProcessData([
              1,
              "create",
              selectedNode.classify_structure_type_id,
              values.name,
              9,
              response.data["classify_structure_type_id"],
              response.data["classify_structure_type_id"],
              [],
              { ...values, ...data, ...response.data },
            ]);
            console.log(
              JSON.parse(
                JSON.stringify({ ...values, ...data, ...response.data })
              )
            );
          } else {
            message.error(`新增失敗，${response.data.message}`);
          }
        })
        .catch((error) => { })
        .finally(() => {
          setCheckStrictly(false);
          setModalData((prev) => {
            return {
              ...prev,
              edit: true,
              // prefix: "permission",
              // languageKey: "permission_language_data",
              node: [],
              data: {
                name: "",
                pathCheck: false,
                path: "",
                show: true,
                property_json: {},
                subheading: "",
              },
            };
          });
        });
    } else {
      axios
        .post(url, data)
        .then((response) => {
          if (response.data.status === "success") {
            message.success("新增成功");
            setPermissionProcessData([
              2,
              values.name,
              response.data["classify_structure_type_id"],
              response.data["classify_structure_type_id"],
              0,
              [Date.now()],
              [],
              { ...values, ...data, ...response.data },
            ]);
          } else {
            message.error(`新增失敗，${response.data.message}`);
          }
        })
        .catch((error) => { })
        .finally(() => {
          setCheckStrictly(false);
          setModalData({
            edit: true,
            prefix: "permission",
            languageKey: "permission_language_data",
            node: [],
            data: {
              name: "",
              pathCheck: false,
              path: "",
              show: true,
              property_json: {},
              subheading: "",
            },
          });
        });
    }
  };

  const editModal = (prefix, languageKey, node) => {
    let name = `${node[`${languageKey}`]?.find(tmp => tmp.language_culture_code === "zh-tw")?.language_culture_value !== undefined
      ? node[`${languageKey}`]?.find(tmp => tmp.language_culture_code === "zh-tw")?.language_culture_value
      : node.name
      }`;
    let nameEn = `${node[`${languageKey}`]?.find(tmp => tmp.language_culture_code === "en")?.language_culture_value !== undefined
      ? node[`${languageKey}`]?.find(tmp => tmp.language_culture_code === "en")?.language_culture_value
      : node.name
      }`;
    console.log({
      node,
    });
    let data = {
      name: name,
      nameEn: nameEn,
      pathCheck: node.path_check === 1,
      show: node.show === 1,
      property_json: node.property_json,
      subheading: node.subheading,
    };

    // if (true) {
    if (node.path_check === 0) {
      setCheckStrictly(true);
      data = {
        name: name,
        nameEn: nameEn,
        pathCheck: true,
        path: node.path,
        show: node.show === 1,
        property_json: node.property_json,
        subheading: node.subheading,
      };
    }
    setColorData({ ...node.property_json });
    setFontData({ ...node.property_json });
    setModalData({
      edit: true,
      prefix: prefix,
      languageKey: languageKey,
      node: node,
      data: data,
    });
    setModalShow(true);
  };
  const editPermissionNode = (node, newData) => {
    console.log(newData);
    console.log(node);
    let url = `/dynamicWebsite/backend/permission`;

    let data = [
      {
        permission_id: node.permission_id,
        classify_structure_id: 5,
        classify_structure_type_id: node.classify_structure_type_parent_id,
        name: newData.name,
        show: newData.show ? 1 : 0,
        property_json: JSON.stringify({
          ...newData?.property_json,
          ...fontData,
          background_color1:
            newData?.property_json?.background_color1?.metaColor?.toHex()
              ? "#" +
              newData?.property_json?.background_color1?.metaColor?.toHex()
              : modalData?.data?.property_json?.background_color1,
          background_color2:
            newData?.property_json?.background_color2?.metaColor?.toHex()
              ? "#" +
              newData?.property_json?.background_color2?.metaColor?.toHex()
              : modalData?.data?.property_json?.background_color2,
        }),
        subheading: newData.subheading,
        permission_language_data: [
          {
            language_culture_code: "zh-tw",
            language_culture_value: newData.name,
          },
          {
            language_culture_code: "en",
            language_culture_value: newData.nameEn,
          },
        ],
        // "path_check": newData.path_check,
      },
    ];
    if (!newData.path_check) {
      data = {
        ...data[0],
        path_check: 1,
      };
    } else {
      data = {
        ...data[0],
        path_check: 0,
      };
    }
    editNode(
      "permission",
      url,
      data,
      node.classify_structure_type_id,
      newData.name
    );
  };
  const editNode = (type, url, data, classify_structure_type_id, newName) => {
    axios
      .patch(url, data)
      .then((response) => {
        // console.log(response.data.status)
        if (response.data.status === "success") {
          message.success("修改成功");
          setPermissionProcessData([
            3,
            "edit",
            classify_structure_type_id,
            newName,
            null,
            null,
            null,
            data,
          ]);
        } else {
          message.error(`修改失敗，${response.data.message}`);
        }
      })
      .catch((error) => { })
      .finally(() => {
        setCheckStrictly(false);
        setModalData({
          edit: true,
          prefix: "permission",
          languageKey: "permission_language_data",
          node: [],
          data: {
            name: "",
            pathCheck: false,
            path: "",
            show: 1,
            property_json: {},
            subheading: "",
          },
        });
      });
  };
  const deletePermissionNode = (node, classify_structure_type_id) => {
    let url = `/dynamicWebsite/backend/permission`;
    let data = [
      {
        permission_id: node.permission_id,
        classify_structure_id: 5,
        classify_structure_type_id: classify_structure_type_id,
      },
    ];
    deleteNode("permission", url, data, classify_structure_type_id);
  };
  const deleteNode = (type, url, data, classify_structure_type_id) => {
    axios
      .delete(url, { data: data })
      .then((response) => {
        // console.log(response.data.status)
        if (response.data.status === "success") {
          message.success("刪除成功");
          setPermissionProcessData([4, "delete", classify_structure_type_id]);
          if (data?.[0]?.permission_id === permissionId) {
            setPermissionId(null);
          }
        } else {
          message.error("刪除失敗");
        }
      })
      .catch((error) => { })
      .finally(() => { });
  };
  const formItemsRender = () => {
    return (
      <>
        <Form.Item label={"英文名稱"} name="nameEn">
          {/* {console.log(checkStrictly)} */}
          <Input />
        </Form.Item>
        <Form.Item label={"連結"} name="pathCheck">
          {/* {console.log(checkStrictly)} */}
          <Switch
            checkedChildren="外部連結"
            unCheckedChildren="內部連結"
            checked={checkStrictly}
            onChange={setCheckStrictly}
          />
        </Form.Item>
        {checkStrictly && (
          <>
            <Form.Item
              label={"連結"}
              name="path"
              rules={[
                {
                  required: true,
                  message: `此為必填項目`,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label={"另開分頁"} name="blank">
              <Switch checkedChildren="是" unCheckedChildren="否" />
            </Form.Item>
          </>
        )}
        {/* <Form.Item label={"狀態"} name="pathCheck" valuePropName="checked">
          <Switch checkedChildren="啟用" unCheckedChildren="停用" />
        </Form.Item> */}

        <Form.Item label={"顯示(副)標題"} name="show" valuePropName="checked">
          <Switch checkedChildren="顯示" unCheckedChildren="不顯示" />
        </Form.Item>
        <Form.Item label={"副標題"} name="subheading">
          {/* {console.log(checkStrictly)} */}
          <Input value={modalData?.data?.subheading} />
        </Form.Item>
        <Form.Item label={"副標題大小"} name={["property_json", "size"]}>
          {/* {console.log(checkStrictly)} */}
          <InputNumber onChange={(val) => setFontData(pre => ({ ...pre, size: val }))} value={modalData?.data?.subheading} />
        </Form.Item>
        <Form.Item style={{ margin: 0, padding: 0 }} label={"副標題效果"}>
          <Row gutter={[16, 0]} style={{ margin: 0, padding: 0 }}>
            <Col>
              <Form.Item
                name={["property_json", "blod"]}
              >
                <Checkbox checked={fontData.blod} onChange={(val) => setFontData(pre => ({ ...pre, blod: val.target.checked }))}>粗體</Checkbox>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name={["property_json", "italic"]}
              >
                <Checkbox checked={fontData.italic} onChange={(val) => setFontData(pre => ({ ...pre, italic: val.target.checked }))}>斜體</Checkbox>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name={["property_json", "text-decoration"]}
              >
                <Checkbox checked={fontData.textDecoration} onChange={(val) => setFontData(pre => ({ ...pre, textDecoration: val.target.checked }))}>底線</Checkbox>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item style={{ margin: 0, padding: 0 }} label={"顏色"}>
          <Row gutter={[16, 0]} style={{ margin: 0, padding: 0 }}>
            <Col>
              <Form.Item
                label={"左邊顏色："}
                name={["property_json", "background_color1"]}
              >
                <ColorPicker
                  format={"hex"}
                  value={colorData?.background_color1}
                  onChange={(color) =>
                    setColorData((pre) => ({
                      ...pre,
                      background_color1: `${color.metaColor.toHexString()}`,
                    }))
                  }
                ></ColorPicker>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                label={"右邊顏色："}
                name={["property_json", "background_color2"]}
              >
                <ColorPicker
                  format={"hex"}
                  value={colorData?.background_color2}
                  onChange={(color) =>
                    setColorData((pre) => ({
                      ...pre,
                      background_color2: `${color.metaColor.toHexString()}`,
                    }))
                  }
                ></ColorPicker>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Row
          justify={"center"}
          align="middle"
          style={{
            backgroundImage: `linear-gradient(to right, ${colorData?.background_color1 || "#ffffff"
              }, #ffffff, ${colorData?.background_color2 || "#ffffff"})`,
            position: "relative",
            padding: 0,
          }}
        >
          <Col style={{ textAlign: "center" }}>
            <span
              style={{
                fontSize: fontData.size ? fontData.size : "3vmin",
                fontWeight: fontData.blod ? 900 : "normal",
                fontStyle: fontData.italic ? "italic" : "normal",
                textDecoration: fontData.textDecoration ? "underline" : "none"
              }}>{modalData?.data?.name}</span>
          </Col>
        </Row>
      </>
    );
  };

  const getPermissionId = (node) => {
    if (node) {
      setPermissionId(node?.permission_id);
      // let name = node?.permission_language_data[0].language_culture_value
      // setPermissionName(name !== undefined ? name : node?.name)
    } else {
      setPermissionId(null);
    }
  };

  useEffect(() => {
    document.title = `${prefixTitle} | 選單設定`;

    axios
      .get("/dynamicWebsite/backend/permission", {
        params: {
          classify_structure_id: 5,
          classify_structure_type_id: 0,
        },
      })
      .then((response) => {
        setPermissionData(response.data["data"]);
      })
      .catch((error) => { })
      .finally(() => { });
    // }
  }, []);

  return (
    <Row
      gutter={[10, 20]}
      justify="space-around"
      style={{ padding: "10px", backgroundColor: "#f5f5f5" }}
    >
      <InformationModal
        title={"資訊填寫"}
        edit={modalData.edit}
        value={modalData.data}
        treeNode={modalData.node}
        modalShow={modalShow}
        onSubmit={createPermissionNode}
        onChange={editPermissionNode}
        setModalShow={setModalShow}
        cancelModal={cancelModal}
        formItemsRender={formItemsRender}
      ></InformationModal>
      {/* <Col span={6}>
        <Card title="操作說明">
          <Timeline
            mode={"left"}
            items={[
              {
                label: "1",
                children: "Create a services",
              },
              {
                label: "2",
                children: "Solve initial network problems",
              },
              {
                label: "3",
                children: "Technical testing",
              },
              {
                label: "4",
                children: "Network problems being solved",
              },
            ]}
          />
        </Card>
      </Col> */}
      <Col span={24}>
        <Card title="選單設定">
          {/* <Row gutter={[8, 8]} align={"middle"}>
            <Col span={24}>
              <Form name="horizontal_login" layout="inline">
                <Form.Item name="menu" label={`已建立選單數量：`}>
                  <Input placeholder="menu" />
                </Form.Item>
                <Form.Item name="state" label={`啟用中`}>
                  <Input placeholder="state" />
                </Form.Item>
                <Form.Item name="state" label={`停用中`}>
                  <Input placeholder="state" />
                </Form.Item>
              </Form>
            </Col>
          </Row> */}

          <ClassifyStructure
            prefix="permission"
            chartShow={false}
            treeData={permissionData}
            onSubmit={addModal}
            onChange={editModal}
            processData={permissionProcessData}
            deleteNode={deletePermissionNode}
            onSelect={getPermissionId}
          />
        </Card>
      </Col>
    </Row>
  );
};
export default RouteSetting;
